export default __webpack_public_path__ + "static/media/background-blurred.4267f16f.png";